import React from 'react';
import { NavLink } from 'react-router-dom';
import Menu from './Menu';

const LeftSide = () => {

  return (<>
    <div className="br-logo"><NavLink to="/"><span>
	<img src="/images/mojo.png" alt='MOJO'/></span></NavLink></div>
    <div className="br-sideleft overflow-y-auto">
      <Menu />
      <br />
    </div>
  </>)
}
export default LeftSide;